import {
    generateUserId,
    getDeviceType,
    getSiteId,
    formatSiteName,
    getFormattedPhoneWithCC
} from '../helpers'
import {consentEventCategories, pageCategories} from './constants'
import {getSegmentReady} from './config'

const identifyUser = async (email, traits) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return

    const userId = await generateUserId(email)
    segmentAnalytics.identify(userId, {
        ...traits,
        device: getDeviceType(),
        sales_channel: getSiteId()
    })
}

const trackConsentForSegment = async ({category, action, placement}) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return

    segmentAnalytics.track('consent', {
        action: action,
        category: category,
        valid_until: 'unlimited',
        device: getDeviceType(),
        sales_channel: getSiteId(),
        placement: placement
    })
}

const handlePageView = async ({
    category = pageCategories.page,
    title,
    path,
    url,
    search,
    referrer
}) => {
    const segmentAnalytics = await getSegmentReady()
    if (!segmentAnalytics) return

    segmentAnalytics.page(category, title, {
        path,
        title,
        url,
        search: search || '',
        referrer: referrer || ''
    })
}

const handleEmailConsentForSegment = ({siteName, email, emailChecked, placement}) => {
    if (!email) return
    const action = emailChecked ? 'accept' : 'reject'

    trackConsentForSegment({
        category: siteName + consentEventCategories.hecMarketingEmail,
        action,
        placement
    })
    trackConsentForSegment({
        category: siteName + consentEventCategories.hecSaleEmail,
        action,
        placement
    })
    if (siteName === 'HSA') {
        trackConsentForSegment({
            category: siteName + consentEventCategories.hecEducationEmail,
            action,
            placement
        })
    }
}

const handleSMSConsentForSegment = ({siteName, phone, smsChecked, placement}) => {
    if (!phone) return

    const formattedPhone = getFormattedPhoneWithCC(phone, 'US')
    const action = smsChecked ? 'accept' : 'reject'
    trackDoubleOptInForSegment({
        customerPhone: formattedPhone,
        category: siteName + consentEventCategories.hecTextMessage,
        action,
        placement
    })
}

const trackDoubleOptInForSegment = async ({customerPhone, category, action, placement}) => {
    const segmentAnalytics = await getSegmentReady()
    if (segmentAnalytics) {
        segmentAnalytics.track('Double Opt In', {
            action: action,
            source: 'page',
            phone: customerPhone,
            consent_list: [
                {
                    action,
                    category: category,
                    message: ''
                }
            ],
            valid_until: 'unlimited',
            device: getDeviceType(),
            sales_channel: getSiteId(),
            placement: placement
        })
    }
}

const handleAccountCreationForSegment = ({
    siteName,
    email,
    emailChecked,
    phone,
    smsChecked,
    placement
}) => {
    const formattedSiteName = formatSiteName(siteName)
    handleEmailConsentForSegment({
        siteName: formattedSiteName,
        email,
        emailChecked,
        placement
    })
    handleSMSConsentForSegment({
        siteName: formattedSiteName,
        phone,
        smsChecked,
        placement
    })
}

const handleEmailSignupSubmission = ({siteName, email, emailChecked, placement}) => {
    identifyUser(email, {email})
    const formattedSiteName = formatSiteName(siteName)
    handleEmailConsentForSegment({
        siteName: formattedSiteName,
        email,
        emailChecked,
        placement
    })
}

export {
    identifyUser,
    handleEmailSignupSubmission,
    handlePageView,
    handleAccountCreationForSegment,
    trackConsentForSegment
}
